import { createSelector } from 'reselect';
import get from 'lodash/get';

export const googPalNonceSelector = (state) => get(state, 'applicationinternal.googPalNonce');
export const includeGooglePalNonceSelector = (state) => get(state, 'application.setup.includeGooglePalNonce');

export const googPalParamSelector = createSelector(
  [googPalNonceSelector, includeGooglePalNonceSelector],
  (googPalNonce, include) => include && googPalNonce ? `&paln=${googPalNonce}` : '',
);
